import {
  Button,
  Col,
  Form,
  Input,
  Layout,
  message,
  Modal,
  Row,
  Select,
} from "antd";
import React, { useState } from "react";
import { Helmet } from "react-helmet-async";
import Navbar from "../../Components/Navbar/Navbar";
import PageHeader from "../../Components/PageHeader/PageHeader";
import ConfirmAction from "../../Components/ConfirmAction/ConfirmAction";
import { formatString } from "../../Utils/Common";
import CustomTable from "../../Components/Table/CustomTable";
import { postRequest } from "../../Utils/ApiCalls";
import PersistentFooter from "../../Components/PersistentFooter/PersistentFooter";
import { useTableData } from "../../Utils/useTableData";

const Option = Select;

const Branch = () => {
  const [loading, setLoading] = useState("");
  const [showModal, setShowModal] = useState("");
  const [form] = Form.useForm();
  const [selectedRow, setSelectedRow]: any = useState({});

  const {
    dataSource,
    dataSize,
    loading: tableLoading,
    filterConfig,
    setFilterConfig,
    refetch: fetchTableData,
    handleChangePage,
    handlePageSizeChange,
  } = useTableData<any>({
    endpoint: "branches/get",
    initialFilters: { search: "" },
    isFormData: true,
  });

  function clearFields() {
    setSelectedRow({});
    form.resetFields();
  }

  const columns = [
    {
      title: "Identification No.",
      dataIndex: "identification_no",
      key: "identification_no",
    },
    {
      title: "Name",
      dataIndex: "name",
      key: "name",
    },
    {
      title: "Address",
      dataIndex: "address",
      key: "address",
    },
  ];

  async function submitForm(data: any) {
    setLoading("submit");
    var response = await postRequest(
      `branches/${showModal}`,
      { branch_id: selectedRow.id, ...data },
      true
    );
    if (response.success) {
      message.success(formatString(response.data.message));
      setTimeout(() => {
        clearFields();
        setShowModal("");
        setLoading("");
        fetchTableData();
      }, 1000);
    } else {
      setLoading("");
      message.error(
        response?.data?.response?.data?.messages?.error_messages?.[0] ??
          `Failed to ${showModal} branch.`
      );
    }
  }

  async function deleteBranch() {
    var response = await postRequest(
      `branches/delete`,
      {
        branch_id: selectedRow.id,
      },
      true
    );
    if (response.success) {
      message.success(formatString(response.data.message));
      setTimeout(() => {
        setShowModal("");
        clearFields();
        fetchTableData();
      }, 1000);
    } else {
      message.error(
        formatString(
          response?.data?.response?.data?.messages?.error_messages[0] ??
            "Failed to delete branch."
        )
      );
    }
  }

  return (
    <Layout className="page">
      <Helmet>
        <title>Agua Lab ERP System</title>
      </Helmet>
      <Navbar />
      <Layout>
        <Row className="px-3 pt-20 md:px-10 md:pb-10 md:pt-8 w-screen md:w-full pb-[50px] sm:pb-0 overflow-scroll text-textColor">
          <Col xs={24}>
            <PageHeader
              title="Branches"
              withDateRangeFilter={false}
              withAddButton={true}
              addBtnText="Branch"
              onCreate={() => setShowModal("create")}
              withSearchBtn={true}
              onSearch={(value: any) =>
                setFilterConfig((prev: any) => ({
                  ...prev,
                  search: value,
                }))
              }
            />
          </Col>
          <Col span={24}>
            <div className="table-container overflow-auto">
              <div className="min-w-[800px]">
                <CustomTable
                  data={dataSource}
                  columns={columns}
                  rowKey="id"
                  loading={tableLoading}
                  size="small"
                  pagination={{
                    current: filterConfig.page,
                    total: dataSize,
                    showSizeChanger: true,
                    onChange: (page: number) => handleChangePage(page),
                    onShowSizeChange: (_: number, size: number) =>
                      handlePageSizeChange(size),
                  }}
                  handleRowClick={(record: any) => {
                    setShowModal("update");
                    var data = {
                      ...record,
                    };
                    setSelectedRow(data);
                    form.setFieldsValue({ ...data });
                  }}
                />
              </div>
            </div>
          </Col>
        </Row>
      </Layout>
      <Modal
        open={showModal === "create" || showModal === "update"}
        title={`${showModal === "create" ? "Add" : "Edit"} Branch`}
        centered
        footer={null}
        onCancel={() => {
          setShowModal("");
          clearFields();
        }}
        width={800}
        maskClosable={false}
      >
        <div className="max-h-[70vh] overflow-y-auto pr-2">
          <Form form={form} onFinish={submitForm} layout="vertical">
            <Row className="w-full ps-3" gutter={[10, 10]}>
              <Col xs={12}>
                <Form.Item
                  label="Identification No."
                  name="identification_no"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "This field is required.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={12}>
                <Form.Item
                  label="Name"
                  name="name"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "This field is required.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col xs={24}>
                <Form.Item
                  label="Address"
                  name="address"
                  rules={[
                    {
                      required: true,
                      whitespace: true,
                      message: "This field is required.",
                    },
                  ]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col lg={24} className="flex justify-end gap-3">
                <Form.Item>
                  <Button
                    onClick={() => {
                      setShowModal("");
                      clearFields();
                    }}
                  >
                    Cancel
                  </Button>
                </Form.Item>
                {showModal === "update" && (
                  <Form.Item>
                    <ConfirmAction
                      title="Are you sure you want to delete this branch?"
                      onConfirm={() => deleteBranch()}
                    >
                      <Button danger>Delete</Button>
                    </ConfirmAction>
                  </Form.Item>
                )}
                <Form.Item>
                  <Button
                    htmlType="submit"
                    type="primary"
                    loading={loading === "submit"}
                  >
                    Submit
                  </Button>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Modal>
      <PersistentFooter />
    </Layout>
  );
};

export default Branch;
